import { zodResolver } from '@hookform/resolvers/zod';
import React, { useState } from 'react';
// redux
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import * as z from 'zod';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

import Logo from 'assets/images/logo.svg';
import { newPassword } from 'api/auth/forgot-password/newPassword';
import { schemaStep3 } from 'api/auth/types';

// @ts-ignore

export default function CompletePassword() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const uidb64FromUrl = searchParams.get('uidb64');
  const tokenFromUrl = searchParams.get('token');
  const formStep3 = useForm({
    resolver: zodResolver(schemaStep3),
    defaultValues: {
      password: '',
      confirmPassword: '',
      uidb64: uidb64FromUrl || '',
      token: tokenFromUrl || '',
    },
  });
  const { mutate: handleNewPassword } = useMutation({
    mutationFn: newPassword,
    onSuccess: response => {
      if (response) {
        enqueueSnackbar('Password has been reset successfully. Please log in with your new password.', {
          variant: 'success',
        });
        navigate('/login');
      } else if (response.message) {
        enqueueSnackbar('Some error occurred while resetting the password.', {
          variant: 'error',
        });
      }
    },
    onError: (error: any) => {
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage('An error occurred during login');
      }
    },
  });
  const onSubmitStep3 = (data: z.infer<typeof schemaStep3>) => {
    setErrorMessage(null);
    const { confirmPassword, ...payload } = data;
    handleNewPassword(payload);
  };
  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <a href="https://trojan.systems/" className="d-inline-block auth-logo">
                    <img src={Logo} alt="" height="50" />
                  </a>
                </div>
                <p className="mt-3 fs-15 fw-medium text-primary">Smart pest management</p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Create Password</h5>
                  </div>

                  <div className="p-2 mt-4">
                    <form key="form-step-3" onSubmit={formStep3.handleSubmit(onSubmitStep3)}>
                      <div className="row">
                        <div className="mb-3 col-12 d-flex flex-column gap-2">
                          <label className="form-label mb-0">
                            New Password
                            <span className="text-danger">*</span>
                          </label>
                          <Controller
                            control={formStep3.control}
                            name="password"
                            render={({ field, fieldState }) => (
                              <>
                                <input
                                  {...field}
                                  type="password"
                                  className={`form-control ${fieldState.error ? 'is-invalid' : ''}`}
                                  placeholder="Enter new password"
                                />
                                {fieldState.error && <div className="invalid-feedback">{fieldState.error.message}</div>}
                              </>
                            )}
                          />
                          <label className="form-label mb-0">
                            Confirm Password
                            <span className="text-danger">*</span>
                          </label>
                          <Controller
                            control={formStep3.control}
                            name="confirmPassword"
                            render={({ field, fieldState }) => (
                              <>
                                <input
                                  {...field}
                                  type="password"
                                  className={`form-control ${fieldState.error ? 'is-invalid' : ''}`}
                                  placeholder="Enter new password"
                                />
                                {fieldState.error && <div className="invalid-feedback">{fieldState.error.message}</div>}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="mt-4">
                        <button type="submit" style={{ backgroundColor: '#6836D3' }} className="btn text-light w-100">
                          Confirm
                        </button>
                      </div>
                    </form>

                    {errorMessage && (
                      <div className="alert border-0 alert-danger mt-2 text-center" role="alert">
                        <strong>{errorMessage}</strong>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Wait, I remember my password..
                  <Link to="/login" className="fw-semibold text-primary text-decoration-underline">
                    {' '}
                    Sign in{' '}
                  </Link>{' '}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0 text-muted">
                  © {new Date().getFullYear()} Trojan LLC. Crafted with <i className="mdi mdi-heart text-danger" /> by
                  Trojan Systems
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
